import httpRequest from "../utils/httpRequest";
import { get, omit } from "lodash";
import API_URLS from "../utils/apiUrls";

const _ = { get, omit };

const getProfileRecommendations = (
  user_id: number,
  params?: { page?: number; pageSize?: number },
) => {
  const query: Record<string, number> = {};
  if (params?.page) query.page = params.page;
  if (params?.pageSize) query.pageSize = params.pageSize;

  return httpRequest()
    .get(`${API_URLS.getProfileRecommendations(user_id)}`, {
      params: Object.keys(query).length ? query : undefined,
    })
    .then((res) => {
      return {
        flag: true,
        message: _.get(res.data, "message", ""),
        data: _.get(res, "data.data", {}),
        pagination: _.get(res, "data.pagination", {}),
      };
    })
    .catch((err) => {
      return {
        flag: false,
        message: _.get(err, "response.data.message", "Something went wrong"),
        errors: _.get(err, "response.data.errors", {}),
      };
    });
};

const removeProfileRecommendation = (profile_id: number) => {
  return httpRequest()
    .post(`${API_URLS.removeProfileRecommendation(profile_id)}`)
    .then((res) => {
      return {
        flag: true,
        message: _.get(res.data, "message", ""),
        data: _.get(res, "data.data", {}),
      };
    })
    .catch((err) => {
      return {
        flag: false,
        message: _.get(err, "response.data.message", "Something went wrong"),
        errors: _.get(err, "response.data.errors", {}),
      };
    });
};

const profileRecommendationsServices = {
  getProfileRecommendations,
  removeProfileRecommendation,
};

export default profileRecommendationsServices;
